var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11V1H14.4462L20 6.42857V11",
    stroke: "#90A1AD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6V1L20 6H15Z",
    stroke: "#90A1AD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 10,
    transform: "translate(0 13)",
    fill: "#4AB890"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40752 15.5C3.89692 15.5 3 16.4231 3 18C3 19.5769 3.88748 20.5 5.45472 20.5C6.65376 20.5 7.39018 19.9038 7.58845 19.0481L6.41773 18.6635C6.32332 19.2115 6.00232 19.5192 5.43584 19.5192C4.73719 19.5192 4.29345 19.0385 4.29345 18.0096C4.29345 17 4.70887 16.4808 5.44528 16.4808C5.94567 16.4808 6.24779 16.7788 6.36108 17.3558L7.56956 16.9135C7.34297 16.125 6.73873 15.5 5.40752 15.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4523 20.5C11.8591 20.5 12.6049 19.875 12.6049 19.0096C12.6049 18.2115 12.0951 17.7885 10.7167 17.5096C9.9236 17.3462 9.68757 17.1827 9.68757 16.9231C9.68757 16.6731 10.0086 16.4615 10.5373 16.4615C11.1698 16.4615 11.5475 16.7212 11.7741 17.2596L12.6238 16.5192C12.1895 15.8269 11.6041 15.5 10.5184 15.5C9.1211 15.5 8.39412 16.2692 8.39412 17.0481C8.39412 17.8462 8.88507 18.3077 10.3579 18.6058C11.0471 18.75 11.302 18.8846 11.302 19.1058C11.302 19.3654 10.9905 19.5385 10.4334 19.5385C9.79143 19.5385 9.2816 19.3654 9.01724 18.7885L8.26194 19.5769C8.69624 20.2308 9.47987 20.5 10.4523 20.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6593 15.5962L15.4697 19.4808L14.3085 15.5962H12.9206L14.7144 20.4038H16.2062L18 15.5962H16.6593Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25V28H20V25",
    stroke: "#90A1AD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.89b8373fb1aeaa0118e5b8dc1b8cdc5c.svg";
export { ForwardRef as ReactComponent };